export default __webpack_public_path__ + "static/media/upload-close.39cbe232.svg";